module.exports = __webpack_public_path__ + "img/Darty.4edc90f4.jpg";